var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProposedorder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#D9CDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 12H15.5C12.5 12 10.5 13.5 10.5 17V20.56C10.5 20.93 10.88 21.16 11.21 21.01C12.19 20.56 13.32 20.39 14.51 20.6C17.14 21.07 19.07 23.51 19 26.18C18.99 26.6 18.93 27.01 18.82 27.41C18.74 27.72 18.99 28.01 19.31 28.01H25.5C28.5 28.01 30.5 26.51 30.5 23.01V17C30.5 13.5 28.5 12 25.5 12ZM20.5 22.5C19.12 22.5 18 21.38 18 20C18 18.62 19.12 17.5 20.5 17.5C21.88 17.5 23 18.62 23 20C23 21.38 21.88 22.5 20.5 22.5ZM27.75 22C27.75 22.41 27.41 22.75 27 22.75C26.59 22.75 26.25 22.41 26.25 22V18C26.25 17.59 26.59 17.25 27 17.25C27.41 17.25 27.75 17.59 27.75 18V22Z",
    fill: "#6F00FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22C11.29 22 9.5 23.79 9.5 26C9.5 26.75 9.71 27.46 10.08 28.06C10.77 29.22 12.04 30 13.5 30C14.96 30 16.23 29.22 16.92 28.06C17.29 27.46 17.5 26.75 17.5 26C17.5 23.79 15.71 22 13.5 22ZM15.47 25.67L13.34 27.64C13.2 27.77 13.01 27.84 12.83 27.84C12.64 27.84 12.45 27.77 12.3 27.62L11.31 26.63C11.02 26.34 11.02 25.86 11.31 25.57C11.6 25.28 12.08 25.28 12.37 25.57L12.85 26.05L14.45 24.57C14.75 24.29 15.23 24.31 15.51 24.61C15.79 24.91 15.77 25.39 15.47 25.67Z",
    fill: "#6F00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposedorder);
export default __webpack_public_path__ + "static/media/proposedorder.888fa72476f67ae16c58cc09a21abb54.svg";
export { ForwardRef as ReactComponent };